import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { APP_CONFIG } from '@valk-nx/content/app/config/config';
import { environment } from '@valk-nx/content/environments/environment';
import { getContentConfigurationKey } from '@valk-nx/core/lib/ssr/ssr.helper';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { getStoryblokQueryParams } from './app/helpers/storyblok-params.helper';

if (environment.production) {
	enableProdMode();
}

const key = getContentConfigurationKey(window.location.host);
const apiUrl = environment.apiUrl;

const urlParams = new URLSearchParams(window.location.search);
const storyblokQueryParams = getStoryblokQueryParams(urlParams);

// Allow sending cookies (e.g., for session/auth) with cross-origin API requests if explicitly enabled in the environment.
fetch(`${apiUrl}content-config?host=${key}${storyblokQueryParams}`, {
	credentials: environment?.withCredentials ? 'include' : 'same-origin',
})
	.then((resp) => resp.json())
	.then((config) => {
		const clientAppConfig = appConfig;
		clientAppConfig.providers.push({
			provide: APP_CONFIG,
			useValue: config.data,
		});
		return bootstrapApplication(AppComponent, clientAppConfig);
	})
	.catch((err) => console.error(err));
